import styled from 'styled-components'

const StyledContainer = styled.div`
  height: calc(100vh - 80px);
  width: calc(100vw - 100px);
  padding: 24px 240px 24px 240px;
  font-size: 16px;
  box-sizing: border-box;
  background-color: #eff0f3;
  grid-row: 2;
  grid-column: 2 / 4;
  
  @media (max-width: 1024px) {
    width: 100%;
    padding: 24px;
  }
  
  @media (max-width: 768px) {
  grid-row: 4;
  grid-column: 1;
}

    
 @media {max-width: 420px) {
   height: calc(100vh - 110px);
   padding: 24px 0 50px 0;
   font-size: 14px;
 }
`

const StyledNoBuildingText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  height: 100px;
`

const StyledPhoto = styled.div`
  grid-area: photo;
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledImage = styled.img`
  border-radius: 4px;
`

const StyledAddress = styled.div`
  grid-area: address;
  box-sizing: border-box;
  font-weight: normal;
  color: #a4a9b7;
`

const StyledName = styled.div`
  grid-area: name;
  box-sizing: border-box;
  font-weight: bold;
`
export {
  StyledContainer,
  StyledNoBuildingText,
  StyledPhoto,
  StyledImage,
  StyledAddress,
  StyledName
}
